import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  GET_LST_PUB_CASE_STUDY_DATA,
  GET_COUNT_PUB_CASE_STUDY_DATA,
  API_URL_GET_LIST_POSTALS_INITIAL,
} from "manager/http-constants";
import { Table } from "primeng/table";
import {
  CONSTANT,
  DICID_NUMBER,
} from "src/app/shared/constant/constant";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { PlatformComponent } from "../platform.component";
import { DataView } from "primeng/dataview";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-c261",
  templateUrl: "./c261.component.html",
  styleUrls: ["./c261.component.scss", "../platform.component.scss"],
})
export class C261Component extends PlatformComponent {
  // 画面.検索フォーム
  c261SearchForm: FormGroup = this.formBuilder.group({
    case_study_implementation_city: [],

    free_word: [],
  });

  /** テーブル状態 */
  @ViewChild("table") table: Table;

  // 課題・ソリューション種別のAccordion開閉フラグ
  accordion_free_word: boolean = false;

  // 会員種別のAccordion開閉フラグ
  accordion_case_study_implementation_city: boolean = false;

  // 課題・ソリューション結果リスト
  resultCaseStudyDataList: any[] = [];

  // 課題・ソリューション件数格納先
  countCaseStudyData: number = 0;

  // セッション保存名
  sessionTagName: string = "c201SearchConditions";

  cartSelected: any[] = [];

  selectedCity: any;
  accordion_classes_support = new Map();
  selectedCategory: any[] = [];

  accordion_agenda_access_modifiers: boolean = false;

  columnOrder: any;
  generateSearchItems: Object;
  isShowList: boolean = false;
  postalNoList: any[]
  class_id: any;
  // dataView ソートカラム名
  sortField: string;
  // dataView ソート順 (1:昇順, -1:降順)
  sortOrder: number;
  // var multi mode
  modeMulti: boolean = false;
  allChecked: boolean = false;
  mobileLargeCategory: string[] = [];

  @ViewChild("dv")
  dv: DataView;
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.resetSearch();

    this.getResultCaseStudyDataList();

    this.getSpecCodeList(
      DICID_NUMBER.MUNICIPALITIES,
    );

    // 初期処理:クエリパラメータの設定
    this.setQueryParams();
  }

  private resetSearch() {
    this.c261SearchForm.reset();
    this.accordion_free_word = false;
    this.accordion_case_study_implementation_city = false;
  }

  /**
   * 初期処理:クエリパラメータの設定
   */
  private setQueryParams(): void {
    // クエリパラメータ.課題・ソリューション種別
    {
      // クエリパラメータ.課題・ソリューション種別を取得
      const agendaKbn = this.route.snapshot.queryParams.agenda_kbn;

      // 課題・ソリューション種別が存在するか否か
      if (agendaKbn) {
        // 課題・ソリューション種別が存在する場合

        // 課題・ソリューション種別を画面.検索フォームに格納
        this.c261SearchForm
          .get("agenda_kbn")
          .setValue(agendaKbn.split(CONSTANT.COMMA));

        // 課題・ソリューション種別のAccordionを開く
        // this.accordion_agenda_kbn = true;
      }
    }

    // クエリパラメータ.会員種別
    {
      // クエリパラメータ.会員種別を取得
      const classId = this.route.snapshot.queryParams.class_id;

      // 会員種別が存在するか否か
      if (classId) {
        // 会員種別が存在する場合

        // 会員種別を画面.検索フォームに格納
        this.c261SearchForm
          .get("class_id")
          .setValue(classId.split(CONSTANT.COMMA));

        // 会員種別のAccordionを開く
        // this.accordion_class_id = true;
      }
    }

    // クエリパラメータ.カテゴリ
    {
      // クエリパラメータ.カテゴリを取得
      const agenda_category_class_cd2 =
        this.route.snapshot.queryParams.agenda_category_class_cd2;

      // カテゴリが存在するか否か
      if (agenda_category_class_cd2) {
        // カテゴリが存在する場合

        // カテゴリを画面.検索フォームに格納
        this.c261SearchForm
          .get("agenda_category_class_cd2")
          .setValue(agenda_category_class_cd2.split(CONSTANT.COMMA));

        // カテゴリのAccordionを開く
        // this.accordion_category_class_cd2 = true;
      }
    }
  }

  /**
   * 課題・ソリューション結果を取得
   */
  public getResultCaseStudyDataList(screenSearchFlg?: boolean): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let c261SearchForm: any = JSON.parse(
      JSON.stringify(this.c261SearchForm.value)
    );

    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(c261SearchForm) && !screenSearchFlg) {
      let sessionSearchForm = JSON.parse(
        sessionStorage.getItem(this.sessionTagName)
      );
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        // 画面の検索条件に反映する
        this.c261SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        c261SearchForm = JSON.parse(JSON.stringify(this.c261SearchForm.value));
        // 検索条件を元にアコーディオンの開閉フラグを設定
        this.setAccordionFlg(c261SearchForm);
      }
    }

    // 配列をカンマ区切り変換
    {
      c261SearchForm.free_word = c261SearchForm.free_word
        ? c261SearchForm.free_word.toString().trim()
        : CONSTANT.EMPTY_STRING;
      c261SearchForm.case_study_implementation_city = c261SearchForm.case_study_implementation_city
        ? c261SearchForm.case_study_implementation_city.toString()
        : CONSTANT.EMPTY_STRING;
    }
    const endpoint = GET_LST_PUB_CASE_STUDY_DATA;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(endpoint);

    this.dbOperationService
      .getForkJoinPubDataNoTemplate(
        "view_case_study_my_page",
        endpoint,
        c261SearchForm
      )
      .subscribe((response: any) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション結果を格納
          this.resultCaseStudyDataList = response.body;
        } else {
          this.resultCaseStudyDataList = new Array();
        }
        // 検索条件を保持
        sessionStorage.setItem(
          this.sessionTagName,
          JSON.stringify(this.c261SearchForm.value)
        );

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, endpoint);
        //return to first page
        this.dv.first = 0;
      });

    this.dbOperationService
      .gettNoTemplateData(GET_COUNT_PUB_CASE_STUDY_DATA, null, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.countCaseStudyData = response.body.count;
        } else {
          this.countCaseStudyData = 0;
        }
      });
    this.c261SearchForm.get("free_word")?.setValue(c261SearchForm.free_word);
  }
  public getListPostalsInitial(): void {
    this.postalNoList = new Array();
    this.loadingState.loadStart(API_URL_GET_LIST_POSTALS_INITIAL);

    this.dbOperationService
      .getNoTemplateData(API_URL_GET_LIST_POSTALS_INITIAL, {}, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.postalNoList = response.body;
        } else {
          this.postalNoList = new Array();
        }

        this.loadingState.loadSleepEnd(0.3, API_URL_GET_LIST_POSTALS_INITIAL);
      });
  }
  /**
   * カテゴリ大項目
   * @param event チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargeCategory(
    type: string,
    list: any,
    controlName: string
  ): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.c261SearchForm.get(controlName).value;

    // チェック対象小項目リストからコード値のみ取得
    let spCodeList;
    if (controlName !== "agenda_category_class_cd2")
      spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        "sp_code"
      );
    else
      spCodeList = this.commonService.createArrayGetArrayObject(list, "value");
    let result = [];
    // 該当のカテゴリコードを全て削除してresult変数に格納
    if (getList) {
      result = getList.filter((value) => !spCodeList.includes(value));
    }

    // チェック状態の判定

    // チェック状態の場合
    if (type == "checkAll") {
      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    } else {
      result = result.filter((val) => !spCodeList.includes(val));
    }

    // 画面.検索フォーム.地域に設定
    this.c261SearchForm.get(controlName).setValue(result);
  }

  /**
   * カテゴリ中項目
   * @param event チェック状態
   * @param code 大項目コード
   * @param list チェック対象小項目リスト
   */
  public checkMediumCategory(event: any, code: string, list: any): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.c261SearchForm.get("agenda_category_class_cd2").value;

    // チェック状態の判定
    if (event.checked) {
      // チェック状態の場合

      // チェック対象小項目リストからコード値のみ取得
      let spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        "value"
      );

      // チェック対象小項目リストが全てチェック状態の場合
      if (spCodeList.every((spCode) => getList.indexOf(spCode) != -1)) {
        // 画面.検索フォーム.カテゴリに大項目コードを追加
        getList.push(code);

        // 画面.検索フォーム.カテゴリに設定
        this.c261SearchForm.get("agenda_category_class_cd2").setValue(getList);
      }
    } else {
      // 非チェック状態の場合

      // 画面.検索フォーム.カテゴリから大項目コードを削除
      this.c261SearchForm
        .get("agenda_category_class_cd2")
        .setValue(getList.filter((value) => value != code));
    }
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (
        conditions["freeword"] ||
        conditions["agenda_kbn"] ||
        conditions["class_id"] ||
        conditions["category"] ||
        conditions["prefectures"] ||
        conditions["strdate"] ||
        conditions["enddate"] ||
        conditions["industry_id"] ||
        conditions["sdgs_goal"]
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * アコーディオン表示フラグ設定
   */
  public setAccordionFlg(formVal: any): void {
    // 会員種別
    this.accordion_case_study_implementation_city =
      formVal.case_study_implementation_city != null && formVal.case_study_implementation_city?.length != 0 ? true : false;
  }

  public moveC361(id?: any): void {
    this.router.navigate([`pages/platform/c361/${id}`]);
  }

  isDisabledTab(controlName) {
    const value = this.c261SearchForm.get(controlName).value;
    if (value == null) {
      return false;
    } else if (value.length > 0) return true;
    else return false;
  }
  isDisabledMediumTab(medumTabName: string) {
    const value = this.c261SearchForm.get("agenda_category_class_cd2").value;
    for (let index = 0; index < this.categoryList?.length; index++) {
      let tab: any = this.categoryList[index];
      if (medumTabName == tab.class_cd1) {
        for (let index = 0; index < tab.cd2.length; index++) {
          const element = tab.cd2[index];
          if (value && value.indexOf(element.value) != -1) {
            return true;
          }
        }
        break;
      }
    }
    return false;
  }
  /**
   * チェックボックス全選択
   */
  protected setCheckAll(dv: DataView, event: PointerEvent) {
    if (!this.allChecked) {
      this.cartSelected = new Array();
    } else {
      this.cartSelected = this.resultCaseStudyDataList
        .map((i) => i.agenda_agenda_id.toString())
        .slice(dv.first, dv.first + dv.rows);
    }
  }

  /**
   * check overflow of element
   * @param el html element of list
   * @returns
   */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    const isOverflowing =
      el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  isShowMediumCategory(value) {
    return this.mobileLargeCategory.some((cat) => cat == value);
  }
  toggleLargeCategory(valueArray: any[]) {
    this.c261SearchForm.controls.agenda_category_class_cd2.setValue(
      this.c261SearchForm.controls.agenda_category_class_cd2.value?.filter(
        (val) => !valueArray.map((v) => v.value).includes(val)
      )
    );
    this.c261SearchForm.controls.agenda_category_class_cd1.setValue(
      this.mobileLargeCategory
    );
  }
}
